"use client";

import { createContext, ReactNode, useContext } from "react";

import { useInfiniteCarsQuery } from "../../_hooks/useCarsQuery";
import { useFilterContext } from "./FilterContext";
import { ReturnTypeWithPagination, Vehicle } from "@alba-cars/common-modules";

interface CarsQueryContextProps {
  query: ReturnType<typeof useInfiniteCarsQuery>;
  cars?: ReturnTypeWithPagination<Vehicle[]>;
}

const CarsQueryContext = createContext<CarsQueryContextProps | null>(null);

export const CarsQueryProvider = ({
  cars,
  children,
}: {
  cars?: ReturnTypeWithPagination<Vehicle[]>;
  children: ReactNode;
}) => {
  const { queryOptions } = useFilterContext();

  const query = useInfiniteCarsQuery(queryOptions, undefined, cars);

  return <CarsQueryContext.Provider value={{ query, cars }}>{children}</CarsQueryContext.Provider>;
};

export const useSharedCarsQuery = () => {
  const context = useContext(CarsQueryContext);
  if (!context) throw new Error("useSharedCarsQuery must be used within CarsQueryProvider");
  return context.query;
};
